import * as React from "react";
import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import { useApiClient } from "../../../api";

export const FindClassAndAssignDialog = ({
  open,
  setOpen,
  schoolClasses,
  onSuccess,
  teacher = null,
  student = null,
}) => {
  if ((!student && !teacher) || (student && teacher)) {
    throw "Exactly one of student or teacher must be defined";
  }
  const ApiClient = useApiClient();
  const [schoolClass, setSchoolClass] = useState(null);

  const handleSubmit = async () => {
    try {
      let response;
      if (teacher) {
        response = await ApiClient.schools.assignTeachersToClass({
          teachers: [teacher.id],
          schoolClass: schoolClass.id,
        });
      } else {
        response = await ApiClient.schools.assignStudentsToClass({
          students: [student.id],
          schoolClass: schoolClass.id,
        });
      }
      if (response.success) {
        setSchoolClass(null);
        setOpen(false);
        onSuccess();
      } else {
        console.log("Failed to assign to class");
      }
    } catch (error) {
      console.error("Failed to assign to class", error);
    }
  };

  const handleClose = () => {
    setSchoolClass(null);
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth={"md"}
      slotProps={{
        paper: {
          component: "form",
          sx: { backgroundImage: "none" },
        },
      }}
    >
      <DialogTitle>
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          {teacher ? (
            <Typography variant={"h4"}>Add Teacher to Class</Typography>
          ) : (
            <Typography variant={"h4"}>Add Student to Class</Typography>
          )}
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Autocomplete
          disablePortal={false} // or just remove disablePortal
          autoSelect
          options={schoolClasses}
          value={schoolClass}
          onChange={(_, newValue) => setSchoolClass(newValue)}
          getOptionLabel={(option) =>
            option.name
              ? `${option?.name} (Year ${option.yearGroup.yearGroup}, ${option.subject.name})`
              : ""
          }
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          fullWidth
          PopperProps={{
            modifiers: [
              {
                name: "preventOverflow",
                options: {
                  altAxis: true,
                  tether: true,
                },
              },
            ],
          }}
          renderInput={(params) => (
            <TextField {...params} label="Class" placeholder="Choose a class" />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant={"outlined"}>
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          variant={"contained"}
          disabled={!schoolClass?.id}
        >
          Assign
        </Button>
      </DialogActions>
    </Dialog>
  );
};
